<template>
  <VApp class="landing">
    <Background />
    <div class="landing__content-top px-4 px-md-8">
      <LandingHeader class="px-4 px-md-8" />
      <VContainer class="landing-top">
        <VRow class="relative" align-content="start" justify="center" justify-lg="start" wrap>
          <VCol cols="12" lg="7" class="landing-top-right" order-md="2">
            <div class="landing-top-right__wrap">
              <img src="../assets/img/landing/social/social-top.jpg" alt="">
            </div>
          </VCol>
          <VCol cols="12" sm="10" lg="5">
            <div class="landing-top__title">
              {{ $t('title') }}
            </div>
            <div class="landing-top__text">
              {{ $t('top-text') }}
            </div>
            <VBtn
              class="landing-top__btn"
              color="success"
              dark
              :height="$vuetify.breakpoint.xsOnly ? 36 : 52"
              @click="$vuetify.goTo('#register-form')"
            >
              {{ $t('signUp') }}
            </VBtn>
          </VCol>
        </VRow>
      </VContainer>
    </div>
    <div class="how-it-works">
      <VContainer>
        <h2 class="landing-title">
          {{ $t('titleHowItWorks') }}
        </h2>
        <div class="how-it-works__wrap">
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              1
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/social/social-step-1.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText1') }}
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              2
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/social/social-step-2.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText2') }}
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              3
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/social/social-step-3.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText3') }}
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              4
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/social/social-step-4.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText4') }}
            </div>
          </div>
        </div>
        <button class="landing-btn how-it-works__btn" @click="$vuetify.goTo('#register-form')">
          {{ $t('btnExamples') }}
        </button>
      </VContainer>
    </div>
    <LandingSocialInfo />
    <div class="landing-reviews">
      <VContainer>
        <h2 class="landing-title">
          {{ $t('titleReviews') }}
        </h2>
        <Reviews class="landing-reviews__wrap" />
        <div class="text-center d-none">
          <div class="landing__icon">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M34.5159 3.57227H5.48406C2.46008 3.57227 0 6.03242 0 9.05641V34.3231C0 34.7048 0.309375 35.0144 0.69125 35.0144C1.07313 35.0144 1.3825 34.7049 1.3825 34.3231V9.05641C1.3825 6.79477 3.2225 4.95477 5.48406 4.95477H30.8811C29.7479 5.96023 29.0319 7.42586 29.0319 9.05633V38.8036H1.3825V34.3231C1.3825 33.9414 1.07313 35.0144 0.69125 35.0144C0.309375 35.0144 0 34.0005 0 34.3823V39.4948C0 39.8766 0.309375 40.1861 0.69125 40.1861H29.723C30.1049 40.1861 30.4143 39.8766 30.4143 39.4948V9.05641C30.4143 6.79477 32.2543 4.95484 34.5159 4.95484C36.7775 4.95477 38.6175 6.79477 38.6175 9.05641V22.1227H30.4143C30.0324 22.1227 29.8824 22.4322 29.8824 22.8139C29.8824 23.1956 30.0324 23.5052 30.4143 23.5052H39.3088C39.6906 23.5052 40 23.1957 40 22.8139V9.05641C40 6.03242 37.5398 3.57227 34.5159 3.57227Z" fill="white" /><path d="M12.3233 21.4347C12.3222 21.8165 11.2482 22.1226 11.63 22.1238L16.9109 22.1399C17.2926 22.1411 17.6031 21.8325 17.6042 21.4508L17.6385 10.2257C17.6397 9.8438 17.3312 9.53348 16.9494 9.53231L3.70007 9.49186C3.31835 9.49069 3.00788 9.79912 3.00671 10.181L2.97244 21.4061C2.97127 21.788 3.27978 22.0983 3.66157 22.0995L11.63 22.1238C12.0117 22.125 12.3222 21.8165 12.3233 21.4347C12.3245 21.0528 12.016 20.7425 11.6342 20.7413L4.35696 20.7191L4.38702 10.8765L16.2538 10.9127L16.2238 20.7553L11.6342 20.7413C11.2525 20.7401 12.3245 21.0528 12.3233 21.4347Z" fill="white" /><path d="M35.9361 15.498H32.6287C32.2469 15.498 31.9375 15.8075 31.9375 16.1893C31.9375 16.5711 32.2469 16.8805 32.6287 16.8805H35.9361C36.318 16.8805 36.6273 16.571 36.6273 16.1893C36.6273 15.8076 36.3179 15.498 35.9361 15.498Z" fill="white" /><path d="M35.9361 12.1858H32.6287C32.2469 12.1858 31.9375 12.4952 31.9375 12.877C31.9375 13.2588 32.2469 13.5683 32.6287 13.5683H35.9361C36.318 13.5683 36.6273 13.2588 36.6273 12.877C36.6273 12.4952 36.3179 12.1858 35.9361 12.1858Z" fill="white" /><path d="M26.7306 25.2422H9.90609C9.52422 25.2422 9.21484 25.5516 9.21484 25.9334C9.21484 26.3152 9.52422 26.6247 9.90609 26.6247H26.7306C27.1125 26.6247 27.4219 26.3152 27.4219 25.9334C27.4219 25.5516 27.1125 25.2422 26.7306 25.2422Z" fill="white" /><path d="M26.2352 32.6792H21.6248C21.243 32.6792 20.9336 32.9887 20.9336 33.3704C20.9336 33.7522 21.243 34.0617 21.6248 34.0617H26.2352C26.6171 34.0617 26.9265 33.7522 26.9265 33.3704C26.9265 32.9887 26.6171 32.6792 26.2352 32.6792Z" fill="white" /><path d="M26.4653 28.8669H18.1248C17.743 28.8669 17.4336 29.1764 17.4336 29.5582C17.4336 29.94 17.743 30.2494 18.1248 30.2494H26.4653C26.8472 30.2494 27.1566 29.9399 27.1566 29.5582C27.1566 29.1765 26.8471 28.8669 26.4653 28.8669Z" fill="white" /></g><defs><clipPath id="clip0"><rect width="40" height="40" fill="white" transform="translate(0 0.5)" /></clipPath></defs></svg>
          </div>
          <div class="display-2">
            {{ $t('press') }}
          </div>
        </div>
        <LogotypesSlider class="landing__logotypes d-none" :items="inPress" :nogs="true" />
      </VContainer>
    </div>
    <div class="landing__content px-2 px-sm-4 px-md-8" style="padding: 4.25rem 0.5rem;">
      <h2 class="h2 text-center mb-4 mb-sm-6">
        {{ $t('registration') }}
        <LandingForm />
      </h2>
    </div>
    <TheFooter />
  </VApp>
</template>

<script>
import LandingSocialInfo from '@/components/Landing/LandingSocialInfo';
import { HOME_DOMAIN } from '@/helpers/constants';
import TheFooter from '../components/TheFooter.vue';
import Background from '../components/Landing/LandingBackground.vue';
import LandingHeader from '../components/Landing/LandingHeader.vue';
import LogotypesSlider from '../components/Landing/LogotypesSlider.vue';
import Reviews from '../components/Landing/Reviews.vue';
import LandingForm from '../components/Landing/LandingForm.vue';

export default {
  name: 'SocialLanding',
  components: {
    TheFooter,
    LandingSocialInfo,
    Background,
    LandingHeader,
    LogotypesSlider,
    Reviews,
    LandingForm,
  },
  data() {
    return {
      clientsLogotypes: [
        'Accord.png', 'Finhead.png', 'Breggfast.png', 'Appdate.png', 'Bosson.png', 'Bosson.png', 'Bosson.png', 'Accord.png', 'Finhead.png', 'Breggfast.png', 'Appdate.png', 'Bosson.png', 'Bosson.png', 'Bosson.png',
      ],
      inPress: [
        'Adweek.png', 'TNW.png', 'Adotas.png', 'Economic-Times.png', 'Coinspeaker.png', 'TNW.png', 'Adotas.png',
      ],
      HOME_DOMAIN,
    };
  },
  metaInfo() {
    return {
      title: this.$t('slogan'),
      meta: [
        { property: 'og:title', content: 'Huntica' },
        { property: 'og:url', content: `https://${this.HOME_DOMAIN}/` },
        { property: 'og:description', content: this.$t('sloganShort') },
        { property: 'og:image', content: 'https://via.placeholder.com/600x315' },
        { name: 'twitter:card', content: 'summary' },
      ],
    };
  },
};
</script>

<style lang="scss">
  .landing {
    .v-content {
      padding-bottom: 306px !important;
    }
    &.v-application .primary--text {
      color: #3DB7EB !important;
    }
    .dots {
      display: flex;
      justify-content: center;
    }
    .v-carousel__controls  {
      &__item .v-icon {
        width: 10px !important;
        height: 10px !important;
        font-size: 10px !important;
      }

      .v-btn--icon {
        width: auto;
        height: auto;
      }

      .v-item--active {
        color: $success !important;

        .v-icon {
          opacity: 1;
        }
      }
    }
    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin: 0 $spacer;
      transition: 0.3s;
      background: #c4c4c4;
      cursor: pointer;
      &.active {
        background: #71E6F5;
        cursor: default;
      }
    }
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      .v-content {
        padding-bottom: 145px !important;
      }
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      .container:not(.container--fluid) {
        max-width: 1315px;
      }
      .v-content {
        padding-bottom: 154px !important;
      }
    }
  }

  .landing-reviews {
    background: #fff;
    padding: 4.25rem 0.5rem;
    &__wrap {
      padding-top: 1.625rem;
    }
  }
</style>

<style scoped lang="scss">
  .landing {
    position: relative;
    &__content {
      position: relative;
      z-index: 2;
    }
    &__content-top {
      position: relative;
      z-index: 2;
      background: linear-gradient(80.82deg, #0161A7 10.58%, #00B9F3 109.48%);
      overflow: hidden;
      &:before {
        content: '';
        width: 14.5rem;
        height: 12.5rem;
        background: url("../assets/img/landing/social/social-top-bg-img-1.svg") no-repeat center;
        background-size: contain;
        position: absolute;
        left: 0.625rem;
        bottom: 0.625rem;
      }
    }
    &__reviews, &__faq {
      margin-bottom: 60px;
    }
  }
  .landing-title {
    font-size: 2rem;
    line-height: 1.18;
    font-weight: 400;
    text-align: center;
    margin-bottom: 2.5rem;
    color: #000000;
  }
  .landing-btn {
    display: block;
    padding: 0.875rem 1.625rem;
    background: #1FC57F;
    color: #FFFFFF;
    box-shadow: 0 2px 0.25rem rgba(0, 0, 0, 0.24);
    border-radius: 0.25rem;
  }
  .landing-top {
    padding: 6.5rem 0 10.4375rem;
    position: relative;
    &__title {
      padding-top: 2.375rem;
      max-width: 23rem;
      font-size: 2.125rem;
      line-height: 1.32;
      color: #FFFFFF;
      margin-bottom: 1.25rem;
    }
    &__text {
      max-width: 427px;
      font-size: 1.125rem;
      font-weight: 300;
      line-height: 1.44;
      color: #FFFFFF;
      margin-bottom: 1.875rem;
    }
    &__btn {
      width: 12.9375rem;
    }
  }
  .landing-top-right {
    position: relative;
    &:before {
      content: '';
      width: 14.5rem;
      height: 12.5rem;
      background: url("../assets/img/landing/social/social-top-bg-img-1.svg") no-repeat center;
      background-size: contain;
      position: absolute;
      top: -3.875rem;
      left: 5.25rem;
    }
    &__wrap {
      width: 100%;
      padding-left: 5.25rem;
      box-shadow: 0 2.125rem 4rem rgba(13, 131, 208, 0.13);
      &:before {
        content: '';
        width: 8.75rem;
        height: 8.75rem;
        background: linear-gradient(180deg, #57F5B2 -79.42%, #71E6F5 100%);
        opacity: 0.2;
        border-radius: 8px;
        position: absolute;
        top: -1.8125rem;
        left: 0.625rem;
        z-index: 2;
      }
      &:after {
        content: '';
        width: 84%;
        height: 120%;
        background: url("../assets/img/landing/social/social-top-right-bg.svg") no-repeat center;
        background-size: contain;
        position: absolute;
        top: 16%;
        right: -13%;
        z-index: 2;
      }
      img {
        display: inline-block;
        position: relative;
        border-radius: 0.5rem;
        z-index: 3;
      }
    }
  }
  .how-it-works {
    background: #E9F3FE;
    padding: 4.25rem 0 3.625rem;
    &__wrap {
      display: flex;
    }
    &__item {
      padding-top: 2.25rem;
      position: relative;
      margin-right: 5.9375rem;
      margin-bottom: 4rem;
      &:last-child {
        margin-right: 0;
      }
    }
    &__step {
      width: 3.125rem;
      height: 3.125rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #FFFFFF;
      font-weight: 300;
      font-size: 1.125rem;
      color: #666666;
      position: absolute;
      top: 0;
      left: -2.1875rem;
    }
    &__icon-wrap {
      width: 9.4375rem;
      height: 9.4375rem;
      border-radius: 50%;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.25rem;
    }
    &__text {
      max-width: 15rem;
      font-size: 1.125rem;
      font-weight: 300;
      line-height: 1.44;
      color: #333333;
    }
    &__btn {
      margin: 0 auto;
    }
  }
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    .how-it-works {
      padding: 4.25rem 2.5rem 3.625rem;
      &__item {
        margin-right: 4.75rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .landing__content-top {
      &:before {
        width: 12rem;
        height: 10rem;
        left: 0.625rem;
        bottom: 0.625rem;
      }
    }
    .landing-top {
      padding: 6.5rem 0 8rem;
      text-align: center;
      &__title {
        padding-top: 0;
        max-width: 100%;
      }
      &__text {
        max-width: 100%;
      }
      &__btn {
        display: block;
        margin: 0 auto 3rem;
      }
    }
    .landing-top-right {
      text-align: center;
      &:before {
        width: 12rem;
        height: 10rem;
        top: -3.875rem;
        left: 15%;
      }
      &__wrap {
        display: inline-block;
        width: auto;
        padding-left: 0;
        position: relative;
        &:before {
          width: 6.5rem;
          height: 6.5rem;
          top: -1.8125rem;
          left: -4rem;
        }
        &:after {
          top: 16%;
          right: -15%;
        }
      }
    }
    .how-it-works {
      padding: 3.25rem 2rem;
      &__item {
        margin-right: 4.75rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .landing-title {
      font-size: 1.5rem;
      margin-bottom: 1.75rem;
    }
    .landing__content-top {
      background: linear-gradient(66.26deg, #0161A7 21.12%, #00B9F3 300.96%);
      &:before {
        content: none;
      }
    }
    .landing-top {
      padding: 6.5rem 0 4rem;
      &__title {
        font-size: 1.625rem;
        margin-bottom: 1rem;
      }
      &__text {
        font-size: 1rem;
        margin-bottom: 1.875rem;
      }
      &__btn {
        display: block;
        width: 11.8125rem;
        margin: 0 auto;
      }
    }
    .landing-top-right {
      text-align: center;
      margin-bottom: 1rem;
      &:before {
        width: 8.75rem;
        height: 7.5625rem;
        left: -1.125rem;
        bottom: inherit;
        top: 1.125rem;
      }
      &__wrap {
        display: inline-block;
        width: auto;
        padding-left: 0;
        position: relative;
        img {
          width: 100%;
          max-width: 28.5rem;
        }
        &:before {
          width: 4.25rem;
          height: 4.25rem;
          top: -1.75rem;
          left: -1.75rem;
        }
        &:after {
          width: 84%;
          height: 120%;
          top: 19%;
          right: -20%;
        }
      }
    }
    .how-it-works {
      padding: 2.375rem 2rem;
      &__wrap {
        flex-wrap: wrap;
      }
      &__item {
        width: 43%;
        margin-right: 7%;
        margin-bottom: 2.5rem;
        &:last-child {
          margin-right: 0;
        }
      }
      &__icon-wrap {
        width: 7.25rem;
        min-width: 7.25rem;
        height: 7.25rem;
        padding: 1.625rem;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      &__text {
        max-width: 12rem;
        font-size: 0.9375rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .landing-title {
      font-size: 1.125rem;
      margin-bottom: 0.625rem;
    }
    .landing-btn {
      padding: 0.375rem 1.125rem;
    }
    .landing-top {
      padding: 3.125rem 0 1.125rem;
      &__title {
        max-width: 14.5rem;
        font-size: 1.125rem;
        margin: 0 auto 0.5rem;
      }
      &__text {
        max-width: 17.5rem;
        font-size: 0.875rem;
        margin: 0 auto 0.9375rem;
      }
    }
    .landing-top-right {
      margin-bottom: 0;
      &:before {
        width: 8.75rem;
        height: 7.5625rem;
        left: -1.125rem;
        bottom: inherit;
        top: 1.125rem;
      }
      &__wrap {
        img {
          width: 18.75rem;
        }
        &:before {
          width: 21.4375rem;
          height: 17.5625rem;
          top: -1.75rem;
          left: -1.75rem;
          background: url("../assets/img/landing/social/social-top-right-bg-mobile.svg") no-repeat center;
          opacity: 1;
        }
        &:after {
          content: none;
        }
      }
    }
    .how-it-works {
      padding: 1.125rem 0;
      &__wrap {
        flex-wrap: wrap;
      }
      &__item {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 1.125rem 0 0 1.5625rem;
        margin-right: 0;
        margin-bottom: 1.25rem;
      }
      &__step {
        width: 2.125rem;
        height: 2.125rem;
        font-size: 0.875rem;
        left: 0;
      }
      &__icon-wrap {
        width: 5rem;
        min-width: 5rem;
        height: 5rem;
        margin-right: 0.625rem;
        margin-bottom: 0;
        padding: 0.875rem;
      }
      &__text {
        max-width: 100%;
        font-size: 0.875rem;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  title: Нанимай через социальные сети
  top-text: 'С помощью сервиса Huntica вы можете распечатать материалы, которые будут собеседовать ваших кандидатов без использования не специалистов.'
  signUp: Sign up
  titleHowItWorks: How it works
  howItWorksText1: 'Создайте список вакансий'
  howItWorksText2: 'Разместите ссылки в социальных сетях или баннерах'
  howItWorksText3: 'Ваши пользователи переходят по ссылке и проходят собеседование'
  howItWorksText4: 'Смотрите собеседование в удобном интерфейс и принимайте решения.'
  btnExamples: Try Huntica
  titleExamples: Examples of using
  titleReviews: Reviews
  registration: Registration
  slogan: Huntica is the first automated interview service with a real person
  sloganShort: The first automated interview service with a real person
</i18n>
<i18n locale="ru" lang="yaml">
  title: Нанимай через социальные сети
  top-text: 'С помощью сервиса Huntica вы можете распечатать материалы, которые будут собеседовать ваших кандидатов без использования не специалистов.'
  signUp: Зарегистрироваться
  titleHowItWorks: Как это работает
  howItWorksText1: 'Создайте список вакансий'
  howItWorksText2: 'Разместите ссылки в социальных сетях или баннерах'
  howItWorksText3: 'Ваши пользователи переходят по ссылке и проходят собеседование'
  howItWorksText4: 'Смотрите собеседование в удобном интерфейс и принимайте решения.'
  btnExamples: Попробовать Huntica
  titleExamples: Примеры использования
  titleReviews: Отзывы
  registration: Регистрация
  slogan: Huntica — сервис виртуальных собеседований с человеческим лицом
  sloganShort: сервис виртуальных собеседований с человеческим лицом
</i18n>
